import { ContainerProps } from '../../interfaces/container.interface'
import c from 'classnames'
import styles from './Title.module.scss'

const TitleComponent = ({ children }: ContainerProps) => {
    return (
        <h1 className={c(styles.title, 'animate__animated animate__fadeInUp animate__delay-1s')}>{children}</h1>
    )
}

export default TitleComponent
